// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"651":"ac305e8f760671c7","741":"959e420e0abbda82"}[chunkId] + ".js";
};